import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon } from '@mui/icons-material';
import { DASHBOARD_COLORS } from '../dashboardStyles';

const AskGeminiFab = ({ onClick }) => (
  <Tooltip title="Ask Gemini" placement="left">
    <Fab
      aria-label="Ask Gemini"
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: 96,
        right: 24,
        bgcolor: '#7c3aed',
        color: '#fff',
        '&:hover': { bgcolor: '#6d28d9' },
        zIndex: (theme) => theme.zIndex.speedDial,
      }}
    >
      <AutoAwesomeIcon />
    </Fab>
  </Tooltip>
);

export default AskGeminiFab;
